module.exports = __webpack_public_path__ + "static/media/other-services.91a25cbc.svg";